const userToken = {
    token: null
}

export default userToken